import {createContext} from 'react'

export const CommentContext = createContext({});
export const CommentIdContext = createContext({});
export const ReplyIdContext = createContext({});
export const TypeContext = createContext({});